import { NonSerializedInventoryLocation } from '../../../proto/generated/inv_non_serialized_inventory_message_pb';

export class NonSerializedInventoryLocationModel {
  name: string;
  locationName: string;
  quantity: number;
  nonSerializedInventoryId?: number;
  locationId?: number;

  static MapperList(
    source: NonSerializedInventoryLocation[]
  ): NonSerializedInventoryLocationModel[] {
    const list: NonSerializedInventoryLocationModel[] = [];
    source?.forEach((element) => {
      list.push(NonSerializedInventoryLocationModel.Mapper(element));
    });
    return list;
  }

  static Mapper(
    source: NonSerializedInventoryLocation
  ): NonSerializedInventoryLocationModel {
    const destination = new NonSerializedInventoryLocationModel();

    if (source != null) {
      destination.name = source.getName();
      destination.locationName = source.getLocationName();
      destination.quantity = source.getQuantity();
      destination.nonSerializedInventoryId = source.getNonSerializedInventoryId();
      destination.locationId = source.getLocationId();
    }

    return destination;
  }

  static MapperProto(
    source: NonSerializedInventoryLocationModel
  ): NonSerializedInventoryLocation {
    const destination = new NonSerializedInventoryLocation();

    if (source != null) {
      destination.setName(source.name);
      destination.setLocationName(source.locationName);
      destination.setQuantity(source.quantity);
      if (source.nonSerializedInventoryId != null) {
        destination.setNonSerializedInventoryId(source.nonSerializedInventoryId);
      }
      if (source.locationId != null) {
        destination.setLocationId(source.locationId);
      }
    }

    return destination;
  }
}
